/* eslint-disable flowtype/require-valid-file-annotation */

import React from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import HoursNavigation from "./HoursNavigation";
import C from "./../../Constants";
import moment from "moment";
import HoursBody from "./HoursBody";
import EditHourDrawer from "./EditHourDrawer";
import ControllableScrollbar from "../elements/ControllableScrollbar";
import DayNavigation from "./DayNavigation";

const styles = theme => ({
    hoursBody: {
        display: "flex",
        flexFlow: "row",
        width: "100%",
        height: "100%",
        minHeight: 0,
        minWidth: 0,
    },
    hoursContainer: {
        flex: "1 1 auto",
        width: "100%",
        height: "100%",
        minHeight: 0,
        minWidth: 0,
    },
    subBody: {
        display: "flex",
        flex: "1",
        flexFlow: "row",
        overflow: "hidden",
        //minHeight: 0,
        //minWidth: 0,
        width: "100%",
        height: "100%",
    },
    panelBody: {
        flex: "1 1 auto",
        minHeight: 0,
        minWidth: 0,
        width: "100%",
        height: "100%",
        display: "flex",
        flexFlow: "column",
    },
    raster: {
        borderRight: "1px solid #BBB",
        borderBottom: "1px solid #BBB",
        boxSizing: "border-box",
    },
    hour: {
        width: "100%",
        margin: 0,
        padding: 0,
        lineHeight: theme.spacing.unit * 2 + "px",
        overflow: "hidden",
    },
    day: {
        height: "100%",
        flex: "1 1 auto",
        display: "flex",
        flexFlow: "column nowrap",
        boxSizing: "border-box",
    },

    hourRasterDense: {height: "4%", minHeight: theme.spacing.unit * 3, flex: "1 1 auto"},
    hourRasterWide: {height: "4%", minHeight: theme.spacing.unit * 6, flex: "1 1 auto"},
    dayRasterDense: {minWidth: theme.spacing.unit * 15},
    dayRasterWide: {minWidth: theme.spacing.unit * 20},
    hoursNavigationWidth: {minWidth: theme.spacing.unit * 8, width: theme.spacing.unit * 8},
});

class HourPanel extends React.Component {
    scrollTop = 0;
    scrollLeft = 0;
    scrolledToDate = null;

    constructor(props) {
        super(props);
        this.state = {
            editHourDrawerOpen: false,
            scrollToHour: 0,
            dense: true,
        };
    }

    componentWillUnmount() {
        clearInterval(this.updateScrollId);
        clearInterval(this.updateHoursId);
    }

    componentDidMount() {
        this.scrollToSelectedDate();
        //60 fps e.g. 16ms to update frame. fermat says /2 to mimic exact same behavior
        this.updateScrollId = setInterval(this.updateScroll, 16);
        this.updateHoursId = setInterval(this.updateHours, 2000);
    };

    componentDidUpdate() {
        this.scrollToSelectedDate();
    };

    scrollToSelectedDate = () => {
        if (this.props.selectedDate !== this.scrolledToDate) {
            this.scrolledToDate = this.props.selectedDate;
            const {scrollbars} = this.refs;
            const convertedHours = this.convertHoursObjectToArray();
            let scrollToDate = null;
            for (let i = 0; i < convertedHours.length && !convertedHours[i][0].isAfter(this.props.selectedDate); i++) {
                scrollToDate = convertedHours[i][0];
            }
            if (scrollToDate != null) {
                const scrollToDOM = document.getElementById("d" + scrollToDate.format(C.inputDatePatternMomentScriptId));
                if (scrollToDOM != null) {
                    scrollbars.scrollLeft(scrollToDOM.offsetLeft);
                }
            }
        }
    };

    render() {
        const {classes} = this.props;
        const that = this;
        const convertedHours = this.convertHoursObjectToArray();
        return <div className={classes.panelBody}>
            <DayNavigation hoveredDate={this.props.printMode ? null : this.state.hoveredDate} hours={convertedHours}
                           ref="dayNavigation"
                           dense={this.props.dense}
                           onRef={ref => (that.dayRef = ref)}
                           classes={{
                               raster: classes.raster,
                               dayRasterDense: classes.dayRasterDense, dayRasterWide: classes.dayRasterWide,
                               hoursNavigationWidth: classes.hoursNavigationWidth
                           }}/>
            <div className={classes.subBody}>
                <HoursNavigation hoveredHour={this.props.printMode ? null : this.state.hoveredHour}
                                 onRef={ref => (that.hourRef = ref)} dense={this.props.dense}
                                 classes={{
                                     raster: classes.raster, hoursNavigationWidth: classes.hoursNavigationWidth,
                                     hourRasterDense: classes.hourRasterDense, hourRasterWide: classes.hourRasterWide,
                                 }}/>
                <div className={classes.hoursContainer}><ControllableScrollbar ref="scrollbars" className="scrollbarHourPanel"
                                                                               onScrollFrame={this.scrollHappened}>
                    <div className={classes.hoursBody + " hoursBodyContainer"}>
                        <HoursBody ref="hoursBody" hours={convertedHours} dense={this.props.dense}
                                   hourTypes={this.props.hourTypes} hoursPanel={this}
                                   classes={{
                                       raster: classes.raster, day: classes.day, hour: classes.hour,
                                       dayRasterDense: classes.dayRasterDense, dayRasterWide: classes.dayRasterWide,
                                       hourRasterDense: classes.hourRasterDense, hourRasterWide: classes.hourRasterWide
                                   }}/>
                    </div>
                </ControllableScrollbar></div>
            </div>
            <EditHourDrawer open={this.state.editHourDrawerOpen} hour={this.getEditedHour()}
                            contactData={this.props.groupData.contactData} hourTypes={this.props.hourTypes}
                            allowedHourTypes={this.props.groupData.allowedHourTypes} hoursPanel={this}
                            groupData={this.props.groupData} isAdmin={this.props.loginData.isGroupAdmin}/>
        </div>;
    }

    scrollHappened = (values) => {
        this.scrollLeft = values.scrollLeft;
        this.scrollTop = values.scrollTop;
        this.scrollWidth = values.scrollWidth;
        this.clientWidth = values.clientWidth;
    }
    updateScroll = () => {
        try {
            if (this.hourRef != null && this.oldScrollTop != this.scrollTop && this.scrollTop != null) {
                this.oldScrollTop = this.scrollTop;
                this.hourRef.scrollTop(this.scrollTop);
            }
            // update the navigation day bar on the top
            if (this.dayRef != null && this.oldScrollLeft != this.scrollLeft && this.scrollLeft != null) {
                this.oldScrollLeft = this.scrollLeft
                this.dayRef.scrollLeft(this.scrollLeft);
            }
        } catch (e) {
            console.log("failed to scroll: " + e);
        }
    }
    updateHours = () => {
        try {
            if (this.scrollWidth != null && this.scrollLeft != null) {
                const hoursPanelMayHaveMoreHours = this.scrollWidth > 4000;
                const borderDistanceToLoad = 500;
                const isOnLeftBorder = hoursPanelMayHaveMoreHours && this.scrollLeft < borderDistanceToLoad;
                const isOnRightBorder = hoursPanelMayHaveMoreHours && this.scrollLeft > this.scrollWidth - this.clientWidth - borderDistanceToLoad;
                if (isOnRightBorder) {
                    const arrays = this.convertHoursObjectToArray();
                    this.props.app.serverCommunication.serverQueryGroupHours(arrays[arrays.length - 1][0].format(C.inputDatePatternMoment))
                    this.scrollLeft = this.scrollWidth - this.clientWidth - borderDistanceToLoad;
                } else if (isOnLeftBorder) {
                    const arrays = this.convertHoursObjectToArray();
                    this.props.app.serverCommunication.serverQueryGroupHours(arrays[0][0].format(C.inputDatePatternMoment));
                }
            }
        } catch (e) {
            console.log("failed to load hours: " + e);
        }
    }

    convertHoursObjectToArray = () => {
        if (this.convertedHoursArray == null
            || this.groupHours !== this.props.groupHours
            || this.groupsHorsNumberOfDays != Object.keys(this.props.groupHours).length
        ) {
            this.convertedHoursArray = [];
            this.groupsHorsNumberOfDays = Object.keys(this.props.groupHours).length;

            if (this.props.groupHours != null) {
                this.groupHours = this.props.groupHours;
                this.groupHoursPreviously = this.props.groupHours;
                for (let hour in this.props.groupHours) {
                    if (this.props.groupHours.hasOwnProperty(hour)) {
                        this.convertedHoursArray.push([moment(hour, C.inputDatePatternMoment), this.props.groupHours[hour]]);
                    }
                }
                this.convertedHoursArray.sort(function (a, b) {
                    return a[0] < b[0] ? -1 : 1;
                });
            }
        }
        return this.convertedHoursArray;
    };
    hourHovered = (date, hour) => this.setState({hoveredHour: hour, hoveredDate: date.clone()});
    hourSelected = (date, hour) => {
        if(this.props.brushMode === null){
            this.setState({
                editedHour: {hour: hour, date: date.clone()},
                editHourDrawerOpen: true
            });
        } else if (this.props.brushMode == -1){
            this.props.app.serverCommunication.serverDeleteHourAllEntries(this.props.groupData.groupName, date.format(C.inputDatePatternMoment), hour);
        } else {
            this.insertHour(date, hour, "", "", this.props.brushMode, 0);
        }
    };
    toggleEditHourDrawer = () => this.setState({editHourDrawerOpen: !this.state.editHourDrawerOpen});
    insertHour = (date, hour, name, contact, hourType, entryNumber) => {
        this.props.app.serverCommunication.serverInsertHour(this.props.groupData.groupName, date.format(C.inputDatePatternMoment), hour, name, contact, hourType, entryNumber);
        this.setState({editHourDrawerOpen: false});
    };
    updateHour = (date, hour, name, contact, hourType, entryNumber) => {
        this.props.app.serverCommunication.serverUpdateHour(this.props.groupData.groupName, date.format(C.inputDatePatternMoment), hour, name, contact, hourType, entryNumber);
        this.setState({editHourDrawerOpen: false});
    };
    deleteHour = (date, hour, entryNumber) => {
        this.props.app.serverCommunication.serverDeleteHour(this.props.groupData.groupName, date.format(C.inputDatePatternMoment), hour, entryNumber);
        this.setState({editHourDrawerOpen: false});
    };
    deleteHourByName = (date, hour, name, contact) => {
        if(this.props.groupData.groupName != null && this.props.groupData.groupName != "") {
            this.props.app.serverCommunication.deleteHourByName(this.props.groupData.groupName, date.format(C.inputDatePatternMoment), hour, name,contact);
            this.setState({editHourDrawerOpen: false});
        }
    };
    getEditedHour = () => {
        if (this.state.editedHour != null) {
            const dayHours = this.props.groupHours[this.state.editedHour.date.format(C.inputDatePatternMoment)];
            const entries = dayHours != null ? dayHours[this.state.editedHour.hour] : null;
            return {date: this.state.editedHour.date, hour: this.state.editedHour.hour, entries: entries};
        }
    };
}

HourPanel.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles, {name: "hourPanel"})(HourPanel);
